<template>
  <div :class="$style.container">
    <template v-if="showExclusiveOfferMessage">
      <div :class="$style.exclusiveMessage">
        <p>{{ exclusiveOfferMessage }}</p>
        <button class="primary-outline short fluid" @click="goToDetails">
          {{ translations.seeDetails }}
        </button>
      </div>
    </template>
    <template v-else>
      <div
        v-if="statusMessage"
        :class="$style.statusMessage"
        data-qa="status-message"
        :data-qa-value="statusMessageKey"
        v-html="statusMessage"
      />
      <NsProductQuantitySelector
        :class="$style.quantitySelector"
        :selected="quantity"
        :disabled="disableQuantitySelector"
        :max-available="maxQuantity"
        :translations="translations"
        inline-label
        @select="handleQuantitySelect"
      />
      <button
        v-if="!showAdrOnly"
        class="primary-solid short fluid"
        :disabled="disableAddToCart"
        data-testid="addToCart"
        @click="$emit('add-to-cart', $event)"
      >
        <NsIcon
          :class="$style.addToCartIcon"
          icon-name="icon-smallcart-empty"
        />
        {{ translations.addToCart }}
      </button>
      <button
        v-else
        class="primary-solid short fluid"
        :disabled="disableAddToAdr"
        data-testid="addToAdr"
        @click="$emit('add-to-adr')"
      >
        <NsIcon :class="$style.addToCartIcon" icon-name="icon-refresh" />
        {{ translations.addToAdr }}
      </button>
    </template>
  </div>
</template>

<script>
import { NsIcon } from "@nuskin/design-components";
import NsProductQuantitySelector from "./NsProductQuantitySelector.vue";
import "@nuskin/ns-core-styles/src/dist/main.css";

export default {
  name: "NsProductCardAction",
  components: { NsIcon, NsProductQuantitySelector },
  props: {
    /**
     * Disables the Add To Adr Button
     */
    disableAddToAdr: Boolean,
    /**
     * Disables the Add To Cart Button
     */
    disableAddToCart: Boolean,
    /**
     * Disables the Quantity Selector
     */
    disableQuantitySelector: Boolean,
    /**
     * The Exclusive Offer text
     */
    exclusiveOfferMessage: {
      type: String,
      default: ""
    },
    /**
     * Sets the max quantity for the Quantity Selector
     */
    maxQuantity: {
      type: Number,
      default: null
    },
    /**
     * Sets the quantity for the Quantity Selector
     */
    quantity: {
      type: String,
      default: "1"
    },
    /**
     * Whether to show the exclusive offer message
     */
    showExclusiveOfferMessage: Boolean,
    /**
     * Warning message, if product is out of stock or whatever
     */
    statusMessage: {
      type: String,
      default: ""
    },
    /**
     * Warning message key, for qa testing automation
     */
    statusMessageKey: {
      type: String,
      default: ""
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      required: true
    }
  },
  computed: {
    showAdrOnly() {
      return this.disableAddToCart && !this.disableAddToAdr;
    }
  },
  methods: {
    handleQuantitySelect(value, index) {
      this.$emit("quantity-select", value, index);
    },
    goToDetails() {
      this.$emit("go-to-details");
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/buttons";

.container,
.container * {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

.container {
  display: grid;
  grid-gap: 15px;
  background-color: white;
  padding: 0 20px 20px;
}

.exclusiveMessage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(147, 0, 147, 0.06);
  padding: 15px 20px 25px;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -20px;
}

.exclusiveMessage p {
  margin: 0 7px 10px;
}

.statusMessage {
  font-weight: map.get(typographyVariables.$typography, font-weight-normal);
  color: map.get(colors.$baseColors, color-error);
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.quantitySelector {
  // TODO: remove after design-components update
  display: flex;
  align-items: center;
  justify-content: center;

  ::v-deep span.form-label {
    align-self: unset;
    margin-right: 10px;
  }

  ::v-deep .dropdown-area {
    position: relative;
  }
  // end TODO
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}

.addToCartIcon {
  position: relative;
  top: 1px;
  stroke-width: 1.5px;
}
</style>
